import { render, staticRenderFns } from "./Newsfeed.vue?vue&type=template&id=3a938206&scoped=true"
import script from "./Newsfeed.vue?vue&type=script&lang=js"
export * from "./Newsfeed.vue?vue&type=script&lang=js"
import style0 from "./Newsfeed.vue?vue&type=style&index=0&id=3a938206&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a938206",
  null
  
)

export default component.exports